import { CreditScore as CanadaCreditScorePb } from "@repo/protobuf/gen/kikoff_canada/protobuf/models/credit/credit_score_pb";
import { CreditScoreV2 as UsCreditScorePb } from "@repo/protobuf/gen/web/public/credit_pb";
import Protobuf from "@repo/protobuf/utils";

type CreditScore = {
  score: number;
  generatedAt: Date;
};

export default CreditScore;

export namespace CreditScoreUsa {
  export const normalize = <T extends UsCreditScorePb | undefined>(
    proto: T
  ): CreditScore | Extract<T, undefined> =>
    proto && {
      score: proto.score >= 300 ? proto.score : 0,
      generatedAt: Protobuf.Timestamp.toDate(proto.generatedDate!),
    };
}

export namespace CreditScoreCanada {
  export const normalize = <T extends CanadaCreditScorePb | undefined>(
    proto: T
  ): CreditScore | Extract<T, undefined> =>
    proto && {
      score: proto.score,
      generatedAt: Protobuf.Timestamp.toDate(proto.generatedAt!),
    };
}
